import Toaster from '@ui/Toaster'
import get from 'lodash/get'
export const SEATABLE = 2
export const ALLOCATABLE = 1
export const UNALLOCATABLE = 0
export const WORKSTATION = 'work'
export const HOT_DESK = 'hot_desk'
export const HOTELING_DESK = 'hoteling_desk'
export const NEIGHBORHOOD = 'neighborhood'
export const RESERVED_DESK = 'reserved_desk'
export const PRIMARY_SEAT = 'primary_seat'
export const SECONDARY_SEAT = 'secondary_seat'
export const SHARED = 'shared_desk'
export const MEETING_ROOM = 'meeting_room'
export const LABEL = 'label'
export const PIN = 'Pin'
export const PIN_LABEL = 'Pin::Label'
export const AVAILABLE = 'available'
export const RESERVED = 'reserved'
export const OCCUPIED = 'occupied'

export const workstation = (spaceType) => get(spaceType, 'name') === WORKSTATION
export const meetingRoom = (spaceType) => {
  const name = get(spaceType, 'name')
  return name && name.match(/meeting_/)
}
export const hotDesk = (usageType) => get(usageType, 'name') === HOT_DESK
export const hotelingDesk = (usageType) => get(usageType, 'name') === HOTELING_DESK
export const neighborhoodDesk = (usageType) => get(usageType, 'name') === NEIGHBORHOOD
export const reservedDesk = (usageType) => get(usageType, 'name') === RESERVED_DESK
export const primarySeat = (usageType) => get(usageType, 'name') === PRIMARY_SEAT
export const secondarySeat = (usageType) => get(usageType, 'name') === SECONDARY_SEAT
export const sharedDesk = (usageType) => get(usageType, 'name') === SHARED
export const label = (spaceType) => get(spaceType, 'name') === LABEL
export const pin = (spaceType) => get(spaceType, 'name') === PIN
export const pinLabel = (spaceType) => get(spaceType, 'name') === PIN_LABEL
export const seatable = (spaceType) => get(spaceType, 'interactivityType') === SEATABLE
export const allocatable = (spaceType) => get(spaceType, 'interactivityType') === ALLOCATABLE
export const unallocatable = (spaceType) => get(spaceType, 'interactivityType') === UNALLOCATABLE
export const available = (space) =>
  get(space, 'status') === AVAILABLE || get(space, 'status') === null

export const getUsageType = (type, usageTypes) => usageTypes.find(({ name }) => name === type)

export const getUsageTypeDisplayName = (type, usageTypes) => {
  const ut = usageTypes.find(({ name }) => name === type)
  return ut ? ut.displayName : null
}

export const getSpaceTypeDisplayName = (type, spaceTypes) => {
  const st = spaceTypes.find(({ name }) => name === type)
  return st ? st.displayName : null
}

export const handleError = (error) => {
  Toaster.fail({ error })
}

export const VERY_DENSE = 0.95
export const DENSE = 0.89
export const MEDIUM = 0.62
export const LOW = 0.5
export const SUPER_LOW = 0.3

export function high(d) {
  return d >= VERY_DENSE
}

export function mediumHigh(d) {
  return d >= DENSE && d < VERY_DENSE
}

export function medium(d) {
  return d >= MEDIUM && d < DENSE
}

export function low(d) {
  return d >= LOW && d < MEDIUM
}

export function superLow(d) {
  return d < LOW
}

export const MAPPING = {
  'fe-account-example': '\u0410',
  'fe-add-employee': '\u0411',
  'fe-alert-confirmation-solid': '\u0412',
  'fe-alert-warning-solid': '\u0413',
  'fe-attachment': '\u0414',
  'fe-building': '\u0415',
  'fe-chair': '\u0416',
  'fe-chart': '\u0417',
  'fe-check': '\u0418',
  'fe-check2': '\u0419',
  'fe-coffee': '\u041a',
  'fe-colaborate': '\u041b',
  'fe-defibrillator': '\u041c',
  'fe-dept-sub': '\u041d',
  'fe-dept': '\u041e',
  'fe-download': '\u041f',
  'fe-dragdrop': '\u0420',
  'fe-edit': '\u0421',
  'fe-electrical': '\u0422',
  'fe-elevator': '\u0423',
  'fe-employee-1': '\u0424',
  'fe-employee': '\u0425',
  'fe-error': '\u0426',
  'fe-exit': '\u0427',
  'fe-export-excel': '\u0428',
  'fe-export-pdf': '\u0429',
  'fe-file-cabinet': '\u042a',
  'fe-file-storage': '\u042b',
  'fe-fire-hose': '\u042c',
  'fe-first-aid-kit': '\u042d',
  'fe-floor': '\u042e',
  'fe-fullscreen-down': '\u042f',
  'fe-fullscreen-up': '\u0430',
  'fe-game-room': '\u0431',
  'fe-gym': '\u0432',
  'fe-information': '\u0433',
  'fe-integration': '\u0434',
  'fe-iot': '\u0435',
  'fe-kitchen-cafeteria': '\u0436',
  'fe-lease-costs': '\u0437',
  'fe-less': '\u0438',
  'fe-locations': '\u0439',
  'fe-lounge': '\u043a',
  'fe-manage-list': '\u043b',
  'fe-map': '\u043c',
  'fe-microwave': '\u043d',
  'fe-more': '\u043e',
  'fe-moves': '\u043f',
  'fe-network-wifi': '\u0440',
  'fe-notifications': '\u0441',
  'fe-occupancy': '\u0442',
  'fe-origin': '\u0443',
  'fe-pantry': '\u0444',
  'fe-parents-room': '\u0445',
  'fe-pdf-file': '\u0446',
  'fe-pencil': '\u0447',
  'fe-person': '\u0448',
  'fe-phone': '\u0449',
  'fe-portfolio-add': '\u044a',
  'fe-portfolio': '\u044b',
  'fe-print': '\u044c',
  'fe-printer': '\u044d',
  'fe-recycling': '\u044e',
  'fe-refrigerator': '\u044f',
  'fe-restroom-men': '\u0450',
  'fe-restroom-women': '\u0451',
  'fe-restrooms': '\u0452',
  'fe-scale': '\u0453',
  'fe-security-badge': '\u0454',
  'fe-security-camera': '\u0455',
  'fe-send': '\u0456',
  'fe-settings': '\u0457',
  'fe-share': '\u0458',
  'fe-shower-men': '\u0459',
  'fe-shower-women': '\u045a',
  'fe-shower': '\u045b',
  'fe-spaces': '\u045c',
  'fe-stack': '\u045d',
  'fe-storage-security': '\u045e',
  'fe-storage': '\u045f',
  'fe-success': '\u0460',
  'fe-supplies': '\u0461',
  'fe-times-circle': '\u0462',
  'fe-tower': '\u0463',
  'fe-trash': '\u0464',
  'fe-upload': '\u0465',
  'fe-utilities-closet': '\u0466',
  'fe-visible': '\u0467',
  'fe-warning': '\u0468',
  'fe-water-cooler': '\u0469',
  'fe-wellness-yoga': '\u046a',
  'fe-x-red': '\u046b',

  'fal fa-toilet': '\uf7d8',
  'fal fa-bicycle': '\uf206',
  'fal fa-paw': '\uf1b0',
  'fal fa-wheelchair': '\uf193',
  'fal fa-palette': '\uf53f',
  'fal fa-cookie': '\uf563',
  'fal fa-print': '\uf02f',
  'fal fa-home': '\uf015',
  'fal fa-server': '\uf233',
  'fal fa-fire-extinguisher': '\uf134',
  'fal fa-book-reader': '\uf5da',
  'fal fa-mailbox': '\uf813',
  'fal fa-landmark': '\uf66f',
  'fal fa-restroom': '\uf7bd',
  'fal fa-coffee-togo': '\uf6c5',
  'fal fa-chair': '\uf6c0',
  'fal fa-user-nurse': '\uf82f',
  'fal fa-thermometer': '\uf491',
  'fal fa-hands-wash': '\ue05e',
  'fal fa-biohazard': '\uf780',
  'fal fa-toilet-paper': '\uf71e',
  'fal fa-head-side-mask': '\ue063',
  'fal fa-handshake-alt-slash': '\ue05f',
  'fal fa-hand-sparkles': '\ue05d',
  'fal fa-box-tissue': '\ue05b',
  'fal fa-hand-holding-water': '\uf4c1',
  'fal fa-shield-virus': '\ue06c',
  'fal fa-viruses': '\ue076',
  'fal fa-pump-soap': '\ue06b',
  'fal fa-pump-medical': '\ue06a',
  'fal fa-long-arrow-down': '\uf175',
  'fal fa-long-arrow-up': '\uf176',
  'fal fa-long-arrow-right': '\uf178',
  'fal fa-long-arrow-left': '\uf177',
  'fal fa-level-up': '\uf148',
  'fal fa-level-down': '\uf149',
  'fal fa-chalkboard': '\uf51b',
  'fal fa-ambulance': '\uf0f9',
  'fal fa-do-not-enter': '\uf5ec',
  'fal fa-people-arrows': '\ue068',
  'fal fa-square': '\uf0c8',
  'fal fa-circle': '\uf111',
  'fal fa-fire-alt': '\uf7e4',
}
